import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import {
  fetchPersonnel,
  fetchPersonnelSubordinates,
  fetchPersonnelTraining,
} from 'components/mobileTrainingProfile/helpers/requests';

const usePersonnel = ({ personnelId, select }) =>
  useQuery({
    queryKey: ['personnel', personnelId],
    queryFn: async () => {
      const response = await fetchPersonnel({ personnelId });
      return response.data;
    },
    select,
  });

const hasProcessingAttachments = (response) =>
  (response?.included || []).some(
    (resource) =>
      resource.type === 'attachment' &&
      resource.attributes.attachedProcessed === false,
  );

const usePersonnelTraining = ({
  personnelId,
  pollWhileAttachmentsProcess = false,
  select,
}) =>
  useQuery({
    queryKey: ['personnel', personnelId, 'trainings'],
    queryFn: async () => {
      const response = await fetchPersonnelTraining({ personnelId });
      return response.data;
    },
    // read through the query, as the first argument is the selected data and so differs per caller
    refetchInterval: (_data, query) =>
      (
        pollWhileAttachmentsProcess &&
        hasProcessingAttachments(query.state.data)
      ) ?
        2000
      : false,
    select,
  });

const useInfinitePersonnelSubordinates = ({ personnelId, select }) =>
  useInfiniteQuery({
    queryKey: ['personnel', personnelId, 'subordinates'],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await fetchPersonnelSubordinates({
        personnelId,
        pageParam,
      });
      return response.data;
    },
    getNextPageParam,
    select,
  });

const getNextPageParam = (lastPage, allPages) =>
  lastPage.meta.isLastPage ? undefined : allPages.length + 1;

export { usePersonnel, usePersonnelTraining, useInfinitePersonnelSubordinates };
